export default {
    methods: {
        language(langCode) {
            let lang = '';
            switch(langCode) {
                case 'ro':
                    lang = this.$t('languages.romanian')
                break;
                case 'en':
                    lang = this.$t('languages.english')
                break;
            }
            return lang;
        },
    }
}